import { createRouter, createWebHistory} from 'vue-router';
import { recordPageLoadDuration } from '../common/js/otel-config.js';
import { ref } from 'vue'
import { nextTick } from 'vue'; // 引入Vue的nextTick
import methods from "@/common/js/methods.js";
const iterator = methods.multidimensionalObjectArray();
import { useStore } from '@/store';
const store = useStore();
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
export const routes = [
	{
		path: '/',
		redirect: '/home',
	},
	{
		path: '/home',
		name: 'home',
		meta:{
			title:'首页',
		},
		component: () => import('@/pages/home/index'),
	},
	{
		path: '/live',
		name: 'live',
		meta:{
			title:'直播',
		},
		component: () => import('@/pages/live/index'),
	},
	{
		path: '/matchList',
		name: 'matchList',
		meta:{
			title:'比赛列表',
		},
		component: () => import('@/pages/matchList/index'),
	},
	{
		path: '/message',
		name: 'message',
		meta:{
			title:'消息',
		},
		component: () => import('@/pages/message/index'),
	},
	{
		path: '/personal',
		name: 'personal',
		meta:{
			title:'个人中心',
		},
		component: () => import('@/pages/personal/index1'),
	},
	{
		path: '/personal1',
		name: 'personal1',
		meta:{
			title:'个人中心',
		},
		component: () => import('@/pages/personal/index1'),
	},
	{
		path: '/infodetail',
		name: 'infodetail',
		meta:{
			title:'资讯详情',
		},
		component: () => import('@/pagessub/info/detail'),
	},
	{
		path: '/match',
		name: 'match',
		meta:{
			title:'比赛详情',
		},
		component: () => import('@/pagessub/match/index'),
	},
	{
		path: '/message_chat',
		name: 'message_chat',
		meta:{
			title:'消息聊天室',
		},
		component: () => import('@/pagessub/message/chat'),
	},
	{
		path: '/message_setting',
		name: 'message_setting',
		meta:{
			title:'消息设置',
		},
		component: () => import('@/pagessub/message/msgsetting'),
	},
	{
		path: '/message_system',
		name: 'message_system',
		meta:{
			title:'系统通知',
		},
		component: () => import('@/pagessub/message/systemnotification'),
	},
	{
		path: '/personal_anchorBlacklist',
		name: 'personal_anchorBlacklist',
		meta: {
			title: '黑名单'
		},
		component: () => import('@/pagessub/personal/anchor/anchorBlacklist'),
	},
	{
		path: '/personal_anchorHouseManage',
		name: 'personal_anchorHouseManage',
		meta: {
			title: '房管处理'
		},
		component: () => import('@/pagessub/personal/anchor/anchorHouseManage'),
	},
	{
		path: '/personal_anchorLiveRecords',
		name: 'personal_anchorLiveRecords',
		meta: {
			title: '直播记录'
		},
		component: () => import('@/pagessub/personal/anchor/anchorLiveRecords'),
	},
	{
		path: '/personal_anchorSchedule',
		name: 'personal_anchorSchedule',
		meta: {
			title: '时间表'
		},
		component: () => import('@/pagessub/personal/anchor/anchorSchedule'),
	},
	{
		path: '/personal_anchorSetting',
		name: 'personal_anchorSetting',
		meta: {
			title: '设置'
		},
		component: () => import('@/pagessub/personal/anchor/anchorSetting'),
	},
	{
		path: '/personal_anchorCenter',
		name: 'personal_anchorCenter',
		meta: {
			title: '主播中心'
		},
		component: () => import('@/pagessub/personal/anchorCenter'),
	},
	{
		path: '/personal_commodityDetail',
		name: 'personal_commodityDetail',
		meta: {
			title: '商品详情'
		},
		component: () => import('@/pagessub/personal/IntegralShop/commodityDetail'),
	},
	{
		path: '/personal_exchange',
		name: 'personal_exchange',
		meta: {
			title: '积分兑换'
		},
		component: () => import('@/pagessub/personal/IntegralShop/exchange'),
	},
	{
		path: '/personal_integralBill',
		name: 'personal_integralBill',
		meta: {
			title: '积分兑换'
		},
		component: () => import('@/pagessub/personal/IntegralShop/integralBill'),
	},
	{
		path: '/personal_orderDetail',
		name: 'personal_orderDetail',
		meta: {
			title: '订单详情'
		},
		component: () => import('@/pagessub/personal/IntegralShop/orderDetail'),
	},
	{
		path: '/personal_orderList',
		name: 'personal_orderList',
		meta: {
			title: '订单列表'
		},
		component: () => import('@/pagessub/personal/IntegralShop/orderList'),
	},
	{
		path: '/personal_raffle',
		name: 'personal_raffle',
		meta: {
			title: '抽奖'
		},
		component: () => import('@/pagessub/personal/IntegralShop/raffle'),
	},
	{
		path: '/personal_myRaffle',
		name: 'personal_myRaffle',
		meta: {
			title: '我的抽奖'
		},
		component: () => import('@/pagessub/personal/IntegralShop/myRaffle'),
	},
	{
		path: '/prize_details',
		name: 'prize_details',
		meta: {
			title: '奖品详情'
		},
		component: () => import('@/pagessub/personal/IntegralShop/prizeDetails'),
	},
	{
		path: '/invite_friends',
		name: 'invite_friends',
		meta: {
			title: '邀请好友'
		},
		component: () => import('@/pagessub/personal/IntegralShop/inviteFriends'),
	},
	{
		path: '/activity_rules',
		name: 'activity_rules',
		meta: {
			title: '活动规则'
		},
		component: () => import('@/pagessub/personal/IntegralShop/activityRules'),
	},
	{
		path: '/browser_address',
		name: 'browser_address',
		meta: {
			title: '浏览器地址'
		},
		component: () => import('@/pagessub/personal/IntegralShop/browserAddress'),
	},
	{
		path: '/personal_signIn',
		name: 'personal_signIn',
		meta: {
			title: '签到'
		},
		component: () => import('@/pagessub/personal/IntegralShop/signIn'),
	},
	{
		path: '/personal_funAnswerHall',
		name: 'personal_funAnswerHall',
		meta: {
			title: '趣答大厅'
		},
		component: () => import('@/pagessub/personal/interest/funAnswerHall'),
	},
	{
		path: '/personal_guessDeatil',
		name: 'personal_guessDeatil',
		meta: {
			title: '竞猜详情'
		},
		component: () => import('@/pagessub/personal/interest/guessDeatil'),
	},
	{
		path: '/personal_myguessing',
		name: 'personal_myguessing',
		meta: {
			title: '我的竞猜'
		},
		component: () => import('@/pagessub/personal/interest/myguessing'),
	},
	{
		path: '/personal_myrecord',
		name: 'personal_myrecord',
		meta: {
			title: '我的参与记录'
		},
		component: () => import('@/pagessub/personal/interest/myrecord'),
	},
	{
		path: '/personal_mysuccess',
		name: 'personal_mysuccess',
		meta: {
			title: '我的战绩'
		},
		component: () => import('@/pagessub/personal/interest/mysuccess'),
	},
	{
		path: '/personal_playInstructions',
		name: 'personal_playInstructions',
		meta: {
			title: '玩法说明'
		},
		component: () => import('@/pagessub/personal/interest/playInstructions'),
	},
	{
		path: '/personal_revenueRank',
		name: 'personal_revenueRank',
		meta: {
			title: '收益排行榜'
		},
		component: () => import('@/pagessub/personal/interest/revenueRank'),
	},
	{
		path: '/personal_toanswer',
		name: 'personal_toanswer',
		meta: {
			title: '我的趣答'
		},
		component: () => import('@/pagessub/personal/interest/toanswer'),
	},
	{
		path: '/personal_bindingPhone',
		name: 'personal_bindingPhone',
		meta: {
			title: '绑定手机号'
		},
		component: () => import('@/pagessub/personal/bindingPhone'),
	},
	{
		path: '/personal_followAndFans',
		name: 'personal_followAndFans',
		meta: {
			title: '粉丝关注'
		},
		component: () => import('@/pagessub/personal/followAndFans'),
	},
	{
		path: '/personal_forget',
		name: 'personal_forget',
		meta: {
			title: '设置密码'
		},
		component: () => import('@/pagessub/personal/forget'),
	},
	{
		path: '/personal_information', 
		name: 'personal_information',
		meta: {
			title: '编辑资料'
		},
		component: () => import('@/pagessub/personal/information'),
	},
	{
		path: '/personal_login', 
		name: 'personal_login',
		meta: {
			title: '登录'
		},
		component: () => import('@/pagessub/personal/login'),
	},
	{
		path: '/personal_register', 
		name: 'personal_register',
		meta: {
			title: '注册'
		},
		component: () => import('@/pagessub/personal/register'),
	},
	{
		path: '/search',
		name: 'search',
		meta:{
			title:'搜索',
		},
		component: () => import('@/pagessub/search/index'),
	},
	{
		path: '/search_detail',
		name: 'search_detail',
		meta:{
			title:'搜索详情',
		},
		component: () => import('@/pagessub/search/detail'),
	},
	{
		path: '/search_forUsersOrGroups',
		name: 'search_forUsersOrGroups',
		meta:{
			title:'搜索详情',
		},
		component: () => import('@/pagessub/search/forUsersOrGroups'),
	},
	{
		path: '/setting',
		name: 'setting',
		meta:{
			title:'设置',
		},
		component: () => import('@/pagessub/setting/index'),
	},
	{
		path: '/installGuide',
		name: 'installGuide',
		meta:{
			title:'安装教程',
		},
		component: () => import('@/pagessub/setting/installGuide'),
	},
	{
		path: '/openInstallGuide',
		name: 'openInstallGuide',
		meta:{
			title:'安装教程',
		},
		component: () => import('@/pagessub/setting/openInstallGuide'),
	},
	{
		path: '/policies',
		name: 'policies',
		meta:{
			title:'隐私协议123',
		},
		component: () => import('@/pagessub/setting/policies'),
	},
	{
		path: '/serve',
		name: 'serve',
		meta:{
			title:'服务协议',
		},
		component: () => import('@/pagessub/setting/serve'),
	},
	{
		path: '/searchGroup',
		name: 'searchGroup',
		meta:{
			title:'群聊详情',
		},
		component: () => import('@/pagessub/info/groupDetail'),
	},
	{
		path: '/mySendRedPacketList',
		name: 'mySendRedPacketList',
		meta:{
			title:'红包列表',
		},
		component: () => import('@/components/customChat/MySendRedPacketList'),
	},
	{
		path: '/friendGroups',
		name: 'friendGroups',
		meta:{
			title:'标签列表',
		},
		component: () => import('@/components/customChat/friendGroups'),
	},
	{
		path: '/404',
		name: '404',
		component: () => import('@/components/error/404'),
	},
	{
		path: '/403',
		name: '403',
		component: () => import('@/components/error/403'),
	},
]
const router = createRouter({
	history: createWebHistory(), //createWebHashHistory(), //createMemoryHistory
	routes,
	// 刷新时，滚动条位置还原
	scrollBehavior: () => ({ left: 0, top: 0 })
})

const loginList = [
	// '/message'
]
export const pageLevel = ref(0) 
let routeObjectArray = new iterator(routes,{key:'path'});
router.beforeEach(async (to, from) => {
	// WEB path 兼容映射
	const webPathMap = {
		'/liveroomdetails': '/match',
		'/schedule':       '/matchList',
		'/message/msg':    '/message',
	}
	const lowerPath = to.path.toLowerCase()
	const target = webPathMap[lowerPath]
	if (target) {
		// 保留所有 query 参数，replace 到 H5 正确路由
		return {
			path: target,
			query: to.query,
			replace: true,
		}
	}
	if (from.name) {
		pageLevel.value++
	}
	if (to.path.includes('/u/') && to.path.startsWith('/u/')) {
	  console.log('检测到二维码路径');
	  const userId = to.path.split('/u/')[1] || '';
	  const hasToken = localStorage.getItem('qx2token');
	  if (hasToken) {
		return {
		  path: `/search_forUsersOrGroups`,
		  query: {
			qr_user: userId,          // 传递用户ID
			auto_search: 'true',      // 标识需要自动搜索
			from_qr: 'true'           // 标识来自二维码
		  },
		  replace: true
		};
	  } else {
		return {
		  path: '/personal_login',
		};
	  }
	}	
	if (to.path.includes('/lr/')  && to.path.startsWith('/lr/')) {
		console.log('检测到二维码路径');
		const roomId = to.path.split('/lr/')[1] || '';
		const hasToken = localStorage.getItem('qx2token');
		if (hasToken) {
		  return {
			path: `/match`,
			query: {
			  qr_user: roomId, 
			},
			replace: true
		  };
		} else {
		  return {
			path: '/personal_login',
		  };
		}
	  }	
	  if (to.path.includes('/g/')  && to.path.startsWith('/g/')) {
		console.log('检测到普通群二维码');
		// 获取路径部分和hash部分
		const pathParts = to.path.split('/g/');
		const pathPart = pathParts[1] || '';  // 获取 @TGS
		const hashPart = window.location.hash.substring(1);  // 获取 _TGHD_4dbc6b46e46a19aa（去掉#号）
		// 组合完整的groupID
		const groupID = pathPart + (hashPart ? '#' + hashPart : '');
		const hasToken = localStorage.getItem('qx2token');
		if (hasToken) {
		  return {
			path: '/searchGroup',
			query: { groupID, from: 'g' }  // 改为 query 传参，from: 'g' 表示普通群
		  };
		} else {
		  sessionStorage.setItem('pendingGroupID', groupID);
		  return {
			path: '/personal_login',
			query:{
				redirectUrl: `/searchGroup?groupID=${encodeURIComponent(groupID)}&from=g`
			},
		  };
		}
	  }
	  if (to.path.includes('/cg/')  && to.path.startsWith('/cg/')) {
		console.log('检测到社群二维码',to);
		// 获取路径部分和hash部分
		const groupID = to.path.split('/cg/')[1] || '';
		const hasToken = localStorage.getItem('qx2token');
		if (hasToken) {
		  return {
			path: '/searchGroup',
			query: { groupID, from: 'cg' }
		  };
		} else {
		  sessionStorage.setItem('pendingGroupID', groupID);
		  return {
			path: '/personal_login',
			query: {
				redirectUrl: `/searchGroup?groupID=${encodeURIComponent(groupID)}&from=cg`
			  }
		  };
		}
	  }
  	to._startTime = performance.now();
	methods.tryIt(() => {
		let body = document.querySelector('body');
		if (/hidden/.test(body.style.overflow)){
			body.style.overflow = 'unset'; //如果body被某些插件设置了overflow:hidden,在路由切换时需要将其解开；
		}
	})
	NProgress.start();
	// if(to.meta&&to.meta.title){
	// 	document.title = to.meta.title;
	// }
	// console.log('NProgress********************', to.query);
	// console.log('localStorage',localStorage)
	const hasToken = localStorage.getItem('qx2token');
	let hasUrlToken = Object.keys(to.query).find(item => item=='token');
	if (hasToken || hasUrlToken) {
		let checkRouter = checkRouterIsHas(to); //检查路由是否存在
		// new RegExp('/participatingTeams').test(to.path)
		if (!checkRouter) return { path: '/404', query:{from:to.path}};
		(function awaitUserID(){
			let _userInfo = localStorage.getItem('qx2userInfo');
			if(_userInfo){
				_userInfo = JSON.parse(_userInfo);
			}
			// console.log('NProgress********************', _userInfo);
			if (_userInfo&&_userInfo.id) {
				// let checkRouter = checkRouterIsHas(to); //检查路由是否存在
				// // new RegExp('/participatingTeams').test(to.path)
				// if (!checkRouter) return { path: '/404', query:{from:to.path}};
			} else {
				setTimeout(()=>{
					return awaitUserID();
				},50)
			}
		})();		
	} else {
		// return
		let checkRouter = checkRouterIsHas(to); //检查路由是否存在
		if (!checkRouter) return { path: '/404' };
		let has = loginList.find(e => new RegExp(e).test(to.path));//需要登录的页面
		if(has){
			return { 
				path: `/personal_login`,
				query:{
					redirectUrl:to.path
				},
			};
		}
	}
	// if(to.path == '/test')return false;//return false;取消导航
})
var checkRouterIsHas = (to) => {
	let hasRoute = routeObjectArray.find((e,i,level,parent)=>{
		let path = '';
		//存在parent时需要将父级的path拼接上，进行完整比较，如：/competition/outline
		if(parent){
			let parentPathArr = [];
			let parentPathObjArr = new iterator(parent,{childrenKey:'parent',key:'path'});
			parentPathObjArr.forEach((p,i)=>{
				if(p.path){
					parentPathArr.push(p.path);
				}else{
					if(i=='path')parentPathArr.push(p);
				}
			})
			// 此时获得了父级路由的path
			let parentPath = parentPathArr.reverse() //倒置数组
				.map(e=>!/^\//.test(e)?'/'+e:e) //补上斜杠"/"
				.join('');//拼接为字符串
			path = parentPath + '/' + e.path;
		}else{
			path = e.path;
		}
		return path == to.path;
	})
	console.log('是否存在路由：',hasRoute);
	return hasRoute;
}
router.afterEach(async (to, from) => {
	NProgress.done();
	if (!to._startTime) return; // 兜底：避免异常场景
	await nextTick(); // 等DOM渲染完成
	const renderDuration = performance.now() - to._startTime;
	// 上报指标
	const fullUrl = `${window.location.origin}${to.fullPath}`;
	console.log('Full URL:', fullUrl);
	recordPageLoadDuration(renderDuration, window.__my_res_ver, fullUrl, 'route');
	// 可选：用完清空，避免路由对象冗余
	delete to._startTime;

})

window.vueRoute = router;
export default router;